<template>
	<div id='' class='' v-loading='loading'>
		<div class='gPageBorder'>

			<el-form class='gForm' ref="form" label-position="right" label-width="12.5%" style=''>
				<el-form-item :label="$t('app_appName')">
					<el-input style='width:100%;' class='aeMg contentColor' v-model='appName'></el-input>
					<!-- {{(config.data)? config.data.appName : ''}} -->
				</el-form-item>
				<!-- <el-form-item :label="$t('app_version')" style=''>
          <el-label class='aeMg contentColor'  style=''>{{version}}</el-label>

        </el-form-item>
        <el-form-item :label="$t('app_verTag')">
          <label class='aeMg contentColor'  style=''>{{verTag}}</label>
        </el-form-item>
        <el-form-item :label="$t('app_package')">
          <label class='aeMg contentColor'  style=''>{{spackage}}</label>
        </el-form-item> -->

				<el-form-item :label="$t('app_udState')">
					<el-input class='aeMg contentColor' v-model='appDesc' type='textarea'
						:autosize="{ minRows: 2, maxRows: 1000}" style='width:100%;'></el-input>

				</el-form-item>

				<el-form-item :label="$t('app_selectApp')">
					<el-upload class="upload-demo aeMg" drag accept='' name='fileUpload' :file-list="fileList"
						:on-success="fileUploadSuccess" :before-upload="fileBeforeUpload" :action="fileUploadUrl">

						<span>
							<i v-if='ulinfo.index == 0' :class="ulinfo.icons[ulinfo.index]"></i>

							<div v-else style='margin-top:10px;'>
								<i v-show='ulinfo.index == 1' style='color:#13CE66'
									:class="ulinfo.icons[ulinfo.index]"></i>
								<i v-show='ulinfo.index == 2' style='color:#FF4949'
									:class="ulinfo.icons[ulinfo.index]"></i>
								<p style="margin-top:-5px;color:#8c939d">{{$t('app_version')}}：{{version}}</p>
								<p style="margin-top:-10px;color:#8c939d">{{$t('app_verTag')}}：{{verTag}}</p>
								<p style="margin-top:-10px;color:#8c939d">{{$t('app_package')}}：{{spackage}}</p>
								<el-button type='primary'>{{$t('app_reupload')}}apk/hap</el-button>
							</div>

							<div v-show='ulinfo.index == 0' class="el-upload__text">{{ulinfo.tip}}</div>
						</span>

					</el-upload>
				</el-form-item>

				<!-- <el-form-item :label="$t('app_udType')">
            <el-checkbox class='aeMg contentColor' v-model="updateType">{{$t('app_allUpdate')}}</el-checkbox>
        </el-form-item> -->

				<el-form-item
					style='width:calc(100% + 20px);background:black;height:1px;background:#EAEEFA;margin-left:-10px;'>
				</el-form-item>

				<el-form-item :label="$t('app_distributor')" prop='appTypeValue'>
					<MechanismSelector :data="mechanismData"></MechanismSelector>
				</el-form-item>

				<el-form-item :label="$t('app_type')" prop='appTypeValue'>
					<!-- <el-select  style='width:40%;'
            class='aeMg' v-model="appTypeValue" clearable :placeholder="$t('app_type')">
            <el-option
              v-for="item in appTypes"
              :key="item.appClassifyId"
              :label="item.appClassifyName"
              :value="item.appClassifyId">
            </el-option>
          </el-select> -->

					<el-cascader expand-trigger="hover" :options="appTypes" @change='selectChange'
						:show-all-levels="false" v-model="appTypeValue"></el-cascader>

				</el-form-item>

				<el-form-item :label="$t('app_introl')" prop='appDesc1'>
					<el-input v-model='appDesc1' :autosize="{ minRows: 2, maxRows: 10}" type='textarea'
						style='width:100%;' class='aeMg'></el-input>
				</el-form-item>


				<el-form-item :label="$t('app_icon')" v-loading='loadingSm'>

					<el-upload class="avatar-uploader aeMg" accept='image/*' :action="imgUploadUrl"
						:show-file-list="false" name="file" :on-success="handleSmAvatarSuccess"
						:before-upload="beforeSmAvatarUpload">
						<img v-if="smImageUrl" :src="smImageUrl" class="sm-avatar">
						<i v-else class="el-icon-plus sm-avatar-uploader-icon"></i>
					</el-upload>
					&nbsp;&nbsp;<label class='contentColor'>{{$t('app_iconState')}}</label>
				</el-form-item>
				<el-form-item :label="$t('app_larIcon')" v-loading='loadingBig'>

					<el-upload class="avatar-uploader aeMg" :action="imgUploadUrl" :show-file-list="false"
						accept='image/*' name="file" :on-success="handleBgAvatarSuccess"
						:before-upload="beforeBgAvatarUpload">
						<img v-if="bgImageUrl" :src="bgImageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					&nbsp;&nbsp;<label class='contentColor'>{{$t('app_larIconState')}}</label>
				</el-form-item>
				<el-form-item :label="$t('app_screenShot')" style='background:none;' v-loading='loading1'>
					<div style='text-align:left;margin-left:15px;'>
						<el-upload class="capture" style='margin-left:-10px;' :action="imgUploadUrl"
							:show-file-list="false" accept='image/*' name="file" :before-upload="tipBf"
							:on-success="handleAvatarSuccessCp0">
							<img v-if="cp0" :src="cp0" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i @click='deleteCapture0()' class="el-icon-delete" style='margin-right:10px;'></i>
						<el-upload class="capture" :action="imgUploadUrl" :show-file-list="false" accept='image/*'
							name="file" :before-upload="tipBf" :on-success="handleAvatarSuccessCp1">
							<img v-if="cp1" :src="cp1" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i @click='deleteCapture1()' class="el-icon-delete" style='margin-right:10px;'></i>
						<el-upload class="capture" :action="imgUploadUrl" :show-file-list="false" accept='image/*'
							name="file" :before-upload="tipBf" :on-success="handleAvatarSuccessCp2">
							<img v-if="cp2" :src="cp2" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i @click='deleteCapture2()' class="el-icon-delete" style='margin-right:10px;'></i>
						<el-upload class="capture" :action="imgUploadUrl" :show-file-list="false" accept='image/*'
							name="file" :before-upload="tipBf" :on-success="handleAvatarSuccessCp3">
							<img v-if="cp3" :src="cp3" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i @click='deleteCapture3()' class="el-icon-delete" style='margin-right:10px;'></i>
						<el-upload class="capture" :action="imgUploadUrl" :show-file-list="false" accept='image/*'
							name="file" :before-upload="tipBf" :on-success="handleAvatarSuccessCp4">
							<img v-if="cp4" :src="cp4" class="avatarF">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload><i @click='deleteCapture4()' class="el-icon-delete" style='margin-right:10px;'></i>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type='' @click='cancel' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' @click='uploadApp' style=''>{{$t('app_submit')}}</el-button>

				</el-form-item>

			</el-form><br />



		</div>

	</div>
</template>

<style>
	/* #ae div:nth-of-type(1){text-align:left;} */


	.fs-icon {
		font-size: 18px;
	}

	#aeScreenCut img {
		heigth: 100%;
		width: auto;
	}

	.avatarF {
		height: auto;
		width: 128px;
		display: block;
	}

	/* upload */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}

	/* upload */
	.sm-avatar-uploader-icon {
		font-size: 32px;
		color: #8c939d;
		width: 64px;
		height: 64px;
		line-height: 64px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}

	.cImg {
		height: 200px;
	}
</style>

<script>
	import mm from 'moment'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	export default {
		data() {
			var that = this
			return {
				mechanismData: {
					callback(value) {
						// that.selectChange(value)
						that.getTypeList(value)
						that.distributorId = value
					}
				},
				ulinfo: {
					tip: this.$t('app_ulAppState_2'),
					index: 0,
					icons: ['el-icon-upload', 'el-icon-circle-check fs-icon', 'el-icon-close fs-icon']
				},
				distributorId: '', // window.localStorage['mechanismId']
				updateType: false,
				installType: 0,
				installTypes: [{
					label: this.$t('app_autoInstall'),
					value: 0
				}],
				fileList: [],
				fileSize: 0, // 上传文件大小
				tableData: [],
				md5: '',
				checkDesc: '',
				radio: '1',
				smImageUrl: '',
				smImageUrlValue: '',
				bgImageUrl: '',
				bgImageUrlValue: '', // 上传值
				appUrl: '',
				dialogVisible: false,
				appTypes: [],
				appTypeValue: '',
				appName: '',
				version: '',
				verTag: '',
				spackage: '',
				appDesc: '',
				appDesc1: '',
				loading: 0,
				loading1: 0,
				loadingBig: 0,
				loadingSm: 0,
				config: {},
				cp0: '',
				cp0Value: '',
				cp1: '',
				cp1Value: '',
				cp2: '',
				cp2Value: '',
				cp3: '',
				cp3Value: '',
				cp4: '',
				cp4Value: '',
				captures: []
			}
		},
		components: {
			MechanismSelector
		},
		computed: {
			imgUploadUrl() {
				// return this.$imgUploadUrl
				return this.$urls.picUrl
			},
			fileUploadUrl() {
				// return this.$fileUploadUrl
				// var vl = this.$urls.apkUrl + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang
				var vl = "https://tmsadmin.szzt.com.cn/file-management/tms-server-web/appFile/fileupload.do" + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang
				return vl
			},
			imgPre() {
				return this.$host
			}
		},
		methods: {
			hBlur(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {} else {
						return false
					}
				})
			},
			tipBf() {
				this.loading1 = 1
				return 1
			},
			makeAppPath(url) {
				var path = url
				if (!path) {
					if (this.config.data) {
						path = this.config.data.appUrl
					} else {
						return ''
					}
				}
				var arr = path.split('/')
				return arr[arr.length - 1]
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD')
			},
			deleteCapture0() {
				this.cp0 = ''
				this.cp0Value = ''
			},
			deleteCapture1() {
				this.cp1 = ''
				this.cp1Value = ''
			},
			deleteCapture2() {
				this.cp2 = ''
				this.cp2Value = ''
			},
			deleteCapture3() {
				this.cp3 = ''
				this.cp3Value = ''
			},
			deleteCapture4() {
				this.cp4 = ''
				this.cp4Value = ''
			},
			imgFullUrl(path) {
				if (path) {
					// return this.imgPre + path
					return this.$urls.prefix + path
				} else {
					return ''
				}
			},
			handleSmAvatarSuccess(res, file) {
				// console.log(res)
				this.loadingSm = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.smImageUrlValue = res.data
					this.smImageUrl = URL.createObjectURL(file.raw)
				}
			},
			handleBgAvatarSuccess(res, file) {
				this.loadingBig = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.bgImageUrlValue = res.data
					this.bgImageUrl = URL.createObjectURL(file.raw)
				}
			},
			handleAvatarSuccessCp0(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp0Value = res.data
					this.cp0 = this.imgFullUrl(res.data)
				}
			},
			handleAvatarSuccessCp1(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp1Value = res.data
					this.cp1 = URL.createObjectURL(file.raw)
				}
			},
			handleAvatarSuccessCp2(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp2Value = res.data
					this.cp2 = URL.createObjectURL(file.raw)
				}
			},
			handleAvatarSuccessCp3(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp3Value = res.data
					this.cp3 = URL.createObjectURL(file.raw)
				}
			},
			handleAvatarSuccessCp4(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp4Value = res.data
					this.cp4 = URL.createObjectURL(file.raw)
				}
			},
			beforeSmAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 100) {
					this.$message.error(this.$t('app_fileOver') + '100k')
					return false
				}
				this.loadingSm = 1
				return true
			},
			beforeBgAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 200) {
					this.$message.error(this.$t('app_fileOver') + '200k')
					return false
				}
				this.loadingBig = 1
				return true
			},
			handleRemove(file, fileList) {
				// console.log(file, fileList)
			},
			check(callback) {
				/* console.log(this.fileSize)
				console.log(this.appTypeValue)
				console.log(this.appName)
				console.log(this.version)
				console.log(this.appDesc)
				console.log(this.smImageUrlValue)
				console.log(this.bgImageUrlValue)
				console.log(this.appUrl)
				console.log(this.makeCapture()) */

				if (this.distributorId && this.version && this.appDesc && this.appDesc1 && this.appTypeValue && this
					.appName && this.appUrl /*&& this.smImageUrlValue && this.bgImageUrlValue && this.makeCapture()*/ ) {
					callback()
				} else {
					this.$message(this.$t('app_inputCp'))
				}
			},
			makeCapture() {
				var str = ''
				if (this.cp0Value) {
					str += this.cp0Value + ','
				}
				if (this.cp1Value) {
					str += this.cp1Value + ','
				}
				if (this.cp2Value) {
					str += this.cp2Value + ','
				}
				if (this.cp3Value) {
					str += this.cp3Value + ','
				}
				if (this.cp4Value) {
					str += this.cp4Value + ','
				}
				return str.substring(0, str.length - 1)
				/* arr.forEach((value, index, array) => {
				  path += value.response.data + ','
				})
				return path.substring(0, path.length - 1) */
			},
			uploadApp() {
				if (window[this.$route.path]) {
					this.$message.error(this.$t('app_appLoding'))
					return
				}
				this.check(() => {
					this.loading = 1
					var updateVl = this.updateType ? '0' : '1'
					if (this.$appUrl === 0) {
						this.$updateApp(this.md5, this.fileSize, this.spackage, this.verTag, this.smImageUrlValue,
							this.bgImageUrlValue, this.makeCapture(), this.appDesc, this.config.data
							.applicationid, this.appUrl, this.version, updateVl, this.distributorId, this
							.appName, this.appTypeValue[0], this.appDesc1, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.$message(res.message)
									this.$router.go(-1)
								} else {
									this.$message(res.message)
								}
							}, () => {
								this.loading = 0
							})
					} else {
						this.$updateApp1(this.md5, this.fileSize, this.spackage, this.verTag, this.smImageUrlValue,
							this.bgImageUrlValue, this.makeCapture(), this.appDesc, this.config.data
							.applicationid, this.appUrl, this.version, updateVl, this.distributorId, this
							.appName, this.appTypeValue[0], this.appDesc1, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.$message(res.message)
									this.$setWObj("appDisplay", {
										appid: res.data.appId,
										mech: res.data.distributorId
									});
									this.$router.go(-1)
								} else {
									this.$message(res.message)
								}
							}, () => {
								this.loading = 0
							})
					}

				})
			},
			fileUploadSuccess(res, file) {
				window[this.$route.path] = ''
				/* console.log('file', res)
				if (res.status === 200) {
				  this.appUrl = res.fileUrl
				  this.fileSize = res.appSize
				} */
				this.ulinfo.tip = res.message
				if (res.status === 200) {
					console.log(res)
					this.appUrl = res.fileUrl
					this.fileSize = res.appSize
					this.verTag = res.versionCode
					this.version = res.appVersion
					this.spackage = res.packageName
					this.md5 = res.md5
					this.fileList = [{
						name: file.name
					}]
					this.ulinfo.index = 1
				} else {
					this.ulinfo.index = 2
					this.spackage = ''
					this.version = ''
					this.verTag = ''
					if (!this.config.data.appUrl) {
						this.fileList = []
					} else {
						// this.fileList = [{name: this.makeAppPath(this.config.data.appUrl)}]
						this.fileList = []
					}
					this.$message.error(res.message)
				}
			},
			fileBeforeUpload(file) {
				if (file) {
					var ar = file.name.split('.')
					var type = ar[ar.length - 1]
					if (type === 'apk' || type === 'hap') {
						var limit = 500000 // k单位
						if (file.size / 1000 > limit) {
							this.$message.error(this.$t('app_fileOver') + '500M')
							return false
						}
						window[this.$route.path] = 1
						return true
					} else {
						this.$message.error(this.$t('app_onlyApk_2'))
						return false
					}
				} else {
					this.$message.error(this.$t('app_onlyApk_2'))
					return false
				}
			},
			setCapturesIn(strs) {
				if (strs) {
					var arr = strs.split(',')
					arr.forEach((value, index, array) => {
						switch (index) {
							case 0:
								this.cp0Value = value
								this.cp0 = this.imgFullUrl(value)
								break
							case 1:
								this.cp1Value = value
								this.cp1 = this.imgFullUrl(value)
								break
							case 2:
								this.cp2Value = value
								this.cp2 = this.imgFullUrl(value)
								break
							case 3:
								this.cp3Value = value
								this.cp3 = this.imgFullUrl(value)
								break
							case 4:
								this.cp4Value = value
								this.cp4 = this.imgFullUrl(value)
								break
						}
					})
				}
			},
			setCapturesArr(strs) {
				if (strs) {
					var arr = strs.split(',')
					this.captures = arr
				}
			},
			fillEdit() {
				var data = this.config.data
				console.log(data)
				//this.version = data.appVersion
				this.appDesc1 = data.appDesc
				this.appName = data.appName
				//this.package = data.packagename
				//this.verTag = data.versioncode
				this.appTypeValue = data.appCategoryId.split(',')
				this.smImageUrl = this.imgFullUrl(data.appSmallIcon)
				this.smImageUrlValue = data.appSmallIcon
				this.bgImageUrl = this.imgFullUrl(data.appBigIcon)
				this.bgImageUrlValue = data.appBigIcon
				// this.appUrl = data.appUrl
				// this.fileList = [{name: this.makeAppPath(data.appUrl)}]
				this.ulinfo.index = 0
				this.setCapturesIn(data.appScreenShot)
			},
			getTypeList(mcid) {
				var mc = mcid ? mcid : ''
				this.$gpAppType(mc, (res) => {
					if (res.data.length > 0) {
						this.appTypes = res.data[0].children
					}
				})
				/*this.$getAppTypeList(100000000, 1, (res) => {
				  if (res.status === 200) {
				    console.log(res)
				    this.appTypes = res.data
				  } else {
				    this.$message(res.message)
				  }
				}, '')*/
			},
			cancel() {
				// cancel
				this.$router.go(-1)
			},
			init() {
				this.config = this.$getWObj().appUlNew
				console.log(this.config)

				this.fillEdit()
				/* console.log(this.config)
				switch (this.config.type) { 
				  case 0:
				    this.getTypeList()
				    break
				  case 1:
				    this.getTypeList() 
				    this.fillEdit()
				    break
				  case 2:
				    this.getTypeList()
				    // console.log(this.config.data.appScreenShot)
				    this.setCapturesArr(this.config.data.appScreenShot)
				    this.getAppHistory()
				    break
				  case 3:
				    this.setCapturesArr(this.config.data.appScreenShot)
				    break
				} */
			}
		},
		mounted() {
			this.init()
		}
	}
</script>


// WEBPACK FOOTER //
// appNewVersion.vue?12e65288